import { Component } from '@angular/core';

@Component({
  selector: 'app-signatories-auth',
  templateUrl: './signatories-auth.component.html',
  styleUrls: ['./signatories-auth.component.sass']
})
export class SignatoriesAuthComponent {

}
